import Details from '../views/opportunities/Details'

export default [{
    path: '/opportunities/:opportunityId',
    meta: {
        title: 'Opportunities'
    },
    component: Details
}]
